module.exports = __webpack_public_path__ + "img/swipe-here.c053b367.png";